export default {
    'avatar-large': '700 1.25rem/1.5rem var(--goto-font-family)',
    'avatar-medium': '700 0.875rem/1.25rem var(--goto-font-family)',
    'avatar-small': '700 0.75rem/1rem var(--goto-font-family)',
    'avatar-xlarge': '700 1.625rem/2rem var(--goto-font-family)',
    'avatar-xsmall': '700 0.625rem/1rem var(--goto-font-family)',
    'avatar-xxlarge': '700 2.25rem/3rem var(--goto-font-family)',
    'avatar-xxxlarge': '700 5rem/6.25rem var(--goto-font-family)',
    'body-large': '400 1.125rem/1.5rem var(--goto-font-family)',
    'body-large-strong': '600 1.125rem/1.5rem var(--goto-font-family)',
    'body-medium': '400 1rem/1.5rem var(--goto-font-family)',
    'body-medium-strong': '600 1rem/1.5rem var(--goto-font-family)',
    'body-small': '400 0.875rem/1.5rem var(--goto-font-family)',
    'body-small-strong': '600 0.875rem/1.5rem var(--goto-font-family)',
    'button-large': '600 1rem/1.5rem var(--goto-font-family)',
    'button-medium': '600 0.875rem/1.5rem var(--goto-font-family)',
    'button-small': '600 0.75rem/1.25rem var(--goto-font-family)',
    'button-xlarge': '600 1.125rem/1.5rem var(--goto-font-family)',
    'caption-medium': '400 0.75rem/1.25rem var(--goto-font-family)',
    'caption-medium-strong': '600 0.75rem/1.25rem var(--goto-font-family)',
    'caption-small': '400 0.625rem/1rem var(--goto-font-family)',
    'caption-small-strong': '600 0.625rem/1rem var(--goto-font-family)',
    'code-medium': '400 0.875rem/1.5rem var(--goto-font-family-mono)',
    'code-small': '400 0.75rem/1.25rem var(--goto-font-family-mono)',
    'heading-large': '700 2.25rem/2.5rem var(--goto-font-family)',
    'heading-medium': '600 1.75rem/2rem var(--goto-font-family)',
    'heading-small': '600 1.25rem/1.5rem var(--goto-font-family)',
    'heading-xlarge': '700 3rem/3.25rem var(--goto-font-family)',
};
